import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';

@Component({
  selector: 'page-receita-view',
  templateUrl: 'receita-view.html',
})
export class ReceitaViewPage {

  receita:any;

  constructor(public navCtrl: NavController, public navParams: NavParams) {
    this.receita = navParams.get('receita');
  }

  ionViewDidLoad() {    
  }

}



// WEBPACK FOOTER //
// ./src/pages/receita-view/receita-view.ts